import { Component, Injector, OnInit } from '@angular/core';
import { ComponentContextService, ComponentBase } from 'tnx-shared';
import { TemplateTypes } from 'tnx-admin-service/templateinstance/models';
import { BookmarkService } from 'tnx-admin-service/bookmark/services';
@Component({
    selector: 'bookmark',
    templateUrl: './bookmark.component.html',
    styleUrls: ['./bookmark.component.scss'],
    providers: [ComponentContextService],
})
export class BookmarkComponent extends ComponentBase implements OnInit {
    templateType = TemplateTypes.word;

    constructor(
        protected _injector: Injector,
        protected _bookmarkService: BookmarkService,
    ) {
        super(_injector);
    }

    ngOnInit() {
    }
}

